import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
const benefits = ['Manual completo en formato digital', 'Acceso inmediato después del pago', 'Estrategias probadas para padres hispanos en USA', 'Inversión menor que una cena familiar'];
export function OfferSection() {
  const handlePurchase = () => {
    window.location.href = 'https://proyectopatriarca.com//cart/48883117981936:1';
  };
  return <section className="w-full bg-navy-medium py-16 md:py-24 px-4" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-104">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-6" data-id="element-105">
            Transforma Tu Miedo en{' '}
            <span className="text-gold" data-id="element-106">Estrategia de Hierro</span>
          </h2>
          <p className="font-body text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-107">
            Por solo $6.39, obtén acceso inmediato al manual que transformará tu
            miedo en una estrategia de hierro.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-dark border-2 border-gold rounded-lg p-8 md:p-12 mb-12" data-id="element-108">
            <div className="mb-8" data-id="element-109">
              <div className="flex justify-center mb-6" data-id="element-110">
                <CountdownTimer data-id="element-111" />
              </div>

              <div className="inline-block bg-red-600 text-white text-sm font-bold px-3 py-1 rounded-full mb-4" data-id="element-112">
                76% DE DESCUENTO
              </div>
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-113">
                <span className="text-3xl md:text-4xl font-heading text-gray-500 line-through" data-id="element-114">
                  $27
                </span>
                <span className="text-6xl md:text-7xl font-heading text-gold" data-id="element-115">
                  $6.39
                </span>
              </div>
              <p className="text-gray-400 text-lg" data-id="element-116">
                Inversión única - Oferta por tiempo limitado
              </p>
            </div>

            <ul className="space-y-4 mb-10 text-left max-w-md mx-auto" role="list" data-id="element-117">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.1
            }} className="flex items-start" data-id="element-118">
                  <CheckIcon className="w-6 h-6 text-gold mr-3 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-119" />
                  <span className="font-body text-gray-300 text-lg" data-id="element-120">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <div id="offer" className="flex justify-center" data-id="element-121">
              <CTAButton onClick={handlePurchase} className="w-full md:w-auto" ariaLabel="Comprar el manual por $6.39" data-id="element-122">
                SOY UN PATRIARCA - $6.39
              </CTAButton>
            </div>
          </motion.div>

          <p className="font-body text-gray-400 text-sm" data-id="element-123">
            Acceso inmediato • Formato digital • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}